import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, FormControl, InputLabel, Select, MenuItem,
  FormGroup, FormControlLabel, Checkbox, CircularProgress, Alert, TextField
} from '@mui/material';

const SaveToLibraryDialog = ({ open, onClose, observation, projects, onSave }) => {
  const [saveTarget, setSaveTarget] = useState(true);
  const [saveTemplate, setSaveTemplate] = useState(true);
  const [projectId, setProjectId] = useState('');
  const [templateName, setTemplateName] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSave = async () => {
    if (!projectId) return;
    setSaving(true);
    setError('');
    try {
      await onSave({
        observation_id: observation._id,
        project_id: projectId,
        save_target: saveTarget,
        save_template: saveTemplate,
        template_name: templateName || `${observation.name} Template`,
      });
      onClose();
    } catch (err) {
      setError(err.message || 'Failed to save to library');
    } finally {
      setSaving(false);
    }
  };

  if (!observation) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Save to Library</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Save <strong>{observation.name}</strong> to your target library for reuse.
        </Typography>

        <FormControl fullWidth required sx={{ mt: 2, mb: 2 }}>
          <InputLabel>Project</InputLabel>
          <Select value={projectId} onChange={e => setProjectId(e.target.value)} label="Project">
            {(projects || []).map(p => (
              <MenuItem key={p._id} value={p._id}>{p.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormGroup>
          <FormControlLabel
            control={<Checkbox checked={saveTarget} onChange={e => setSaveTarget(e.target.checked)} />}
            label="Save target(s) to Library"
          />
          <FormControlLabel
            control={<Checkbox checked={saveTemplate} onChange={e => setSaveTemplate(e.target.checked)} />}
            label="Save as Observing Template"
          />
        </FormGroup>

        {saveTemplate && (
          <TextField
            label="Template Name" fullWidth sx={{ mt: 1 }}
            value={templateName}
            onChange={e => setTemplateName(e.target.value)}
            placeholder={`${observation.name} Template`}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancel</Button>
        <Button
          onClick={handleSave}
          variant="contained"
          disabled={saving || !projectId || (!saveTarget && !saveTemplate)}
          startIcon={saving ? <CircularProgress size={16} /> : null}
        >
          {saving ? 'Saving...' : 'Save to Library'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveToLibraryDialog;
